import { CombinatorRendererProps, isOneOfControl, OwnPropsOfControl, RankedTester, rankWith } from '@jsonforms/core';
import { withJsonFormsOneOfProps } from '@jsonforms/react';
import { Select } from '@mantine/core';
import { MantineOneOfBase } from './MantineOneOfBase';

export interface OwnOneOfProps extends OwnPropsOfControl {
  indexOfFittingSchema?: number;
}

export const FileFormatInArrayOneOf = (props: CombinatorRendererProps) => {
  return <MantineOneOfBase componentProps={{ maw: 240 }} simple={true} Component={Select} {...props} />;
};

export const fileFormatInArrayOneOfTester: RankedTester = rankWith(6, isOneOfControl);

export default withJsonFormsOneOfProps(FileFormatInArrayOneOf);
